// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2pHQS","rootCenter":"LoadMoreObserver_rootCenter__2hwnu","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1tcpu"};